<template>
  <div class="radio-button-card" :class="{selected}" @click="handleClick">
    <div class="title-container">
      <div class="circle-container">
        <div class="circle" :class="{checked: selected}"></div>
      </div>
      <div class="title margin-right-s">{{title}}</div>
    </div>
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'RadioButtonCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    selected: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@riseupil/base-ui/src/scss/riseup-colors';
  @import '~@riseupil/base-ui/src/scss/border-radius';
  @import "~@riseupil/base-ui/src/scss/spacings";

  .radio-button-card {
    position: relative;
    padding: 12px;
    padding-top: 24px;
    box-sizing: border-box;
    border: solid 1px $riseup_gray_0;
    border-radius: $ri-border-radius-large;
    flex-shrink: 0;
    color: $riseup_gray_20;

    &.selected {
      color: $riseup_blue;
      border: solid 1px $riseup_blue;
      box-shadow: 0px 4px 13.4px 0px rgba(0, 0, 0, 0.07);
      .radio-button {
        border: solid 6px $riseup_blue;
      }
    }

    .title-container {
      font-size: 16px;
      font-weight: bold;

      display: flex;
      flex-direction: row;
      align-items: center;

      .circle-container {
        display: flex;
        align-items: center;

        .circle {
          display: inline-block;
          height: 30px;
          width: 30px;
          vertical-align: middle;
          text-align: center;
          border-radius: 50%;
          border: 1px solid $riseup_gray_2;
          background-color: $riseup_white;
          position: relative;

          &.checked {
            background-color: $riseup_white;

            &::after {
              content: '';
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background-color: $riseup_blue;
            }
          }
        }
      }
    }
  }

</style>
